if (!customElements.get('product-modal')) {
  customElements.define(
    'product-modal',
    class ProductModal extends ModalDialog {
      constructor() {
        super();
      }

      hide() {
        super.hide();
      }

      show(opener) {
        super.show(opener);
        this.showActiveMedia();
      }

      showActiveMedia() {
        const sectionId = this.id.replace('ProductModal-', '');
        const activeId = this.openedBy ? this.openedBy.getAttribute('data-media-id') : null;
        if (!activeId) return;

        // Find active media first — return early if somehow missing
        const activeMedia = this.querySelector(`[data-media-id="${activeId}"]`);
        if (!activeMedia) return;

        // Gallery-based filtering: hide images from hidden variant slides,
        // but always keep the clicked image visible
        const gallery = document.getElementById(`GalleryViewer-${sectionId}`);
        if (gallery) {
          const visibleIds = new Set([activeId]);
          gallery.querySelectorAll('[data-media-id]').forEach((slide) => {
            if (slide.hasAttribute('data-cv-variant-slide') && slide.style.display === 'none') return;
            const mediaId = slide.dataset.mediaId.replace(`${sectionId}-`, '');
            visibleIds.add(mediaId);
          });
          this.querySelectorAll('[data-media-id]').forEach((item) => {
            item.style.display = visibleIds.has(String(item.dataset.mediaId)) ? '' : 'none';
          });
        }

        // Show only the clicked image, hide all others
        this.querySelectorAll(`[data-media-id]:not([data-media-id="${activeId}"])`).forEach((element) => {
          element.classList.remove('active');
          element.style.display = 'none';
        });

        const activeMediaTemplate = activeMedia.querySelector('template');
        const activeMediaContent = activeMediaTemplate ? activeMediaTemplate.content : null;
        activeMedia.classList.add('active');
        activeMedia.style.display = 'block';
        activeMedia.scrollIntoView();

        const container = this.querySelector('[role="document"]');
        container.scrollLeft = (activeMedia.width - container.clientWidth) / 2;

        if (
          activeMedia.nodeName == 'DEFERRED-MEDIA' &&
          activeMediaContent &&
          activeMediaContent.querySelector('.js-youtube')
        )
          activeMedia.loadContent();
      }
    }
  );
}
